var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29607 0.20393C9.56796 0.475835 9.56796 0.916443 9.29613 1.18814L5.73439 4.74986L9.296 8.31182C9.56788 8.58357 9.56788 9.02435 9.29605 9.29604C9.16349 9.42861 8.98748 9.5 8.80392 9.5C8.62039 9.5 8.44447 9.42863 8.31202 9.29612L4.75031 5.7339L1.18795 9.29586C1.05548 9.42844 0.879496 9.49986 0.696001 9.49986C0.512482 9.49986 0.336408 9.42842 0.203956 9.29591C-0.0679681 9.02391 -0.067968 8.58331 0.203852 8.31168L3.7656 4.74987L0.20436 1.1882C-0.0675266 0.916452 -0.0675267 0.475667 0.204354 0.20393C0.476244 -0.0679765 0.916696 -0.0679765 1.18859 0.20393L4.75029 3.76561L8.31198 0.203935C8.58388 -0.0679765 9.02418 -0.0679765 9.29607 0.20393Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCross);
export default __webpack_public_path__ + "static/media/new_cross.8f40c09e4b742b768d03ae26a0f759be.svg";
export { ForwardRef as ReactComponent };